import React from 'react';
import {
  Grid,
  Typography,
  Card,
  CardContent,
  CardHeader,
  CardActions,
  Button,
  Divider,
  Link,
} from '@mui/material';
import { Circle } from '@mui/icons-material';
import { Image } from 'mui-image';

const ButtonLink = ({ href, label }) => (
  <Button
    size="small"
    variant="text"
    color="primary"
    href={href}
    target="_blank"
    rel="noopener"
  >
    {label}
  </Button>
);

export default function StarLandingPage() {
  return (
    <Grid container>
      <Grid item xs={12} textAlign="center" padding>
        <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
          STAR Scholarship
        </Typography>
      </Grid>
      <Grid item xs={2} />
      <Grid item xs={8} textAlign="center">
        <Typography variant="body1" sx={{ fontStyle: 'italic' }}>
          The P.E.O. STAR Scholarship is a non-renewable $2,500 scholarship for
          graduating women in their final year of high school which must be used
          in the academic year following graduation or it will be forfeited. All
          applicants are recommended by a local P.E.O. chapter.
        </Typography>
      </Grid>
      <Grid item xs={2} />

      <Grid item xs={12} padding>
        <Card
          sx={{
            boxShadow: 3,
            borderRadius: 2,
            overflow: 'auto',
          }}
        >
          <CardHeader
            title="Local Chapter Recommendation Process"
            subheader="The online recommendation form is available August 15 through October 15. Follow the steps below to recommend your candidate."
          />
          <CardContent>
            <Grid container xs={12}>
              <Grid item xs={6}>
                <Typography
                  variant="body1"
                  padding
                  sx={{ fontWeight: 'bold', backgroundColor: 'lightblue' }}
                >
                  Step
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  variant="body1"
                  padding
                  sx={{ fontWeight: 'bold', backgroundColor: 'lightblue' }}
                >
                  Resources
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1" padding>
                  1. Start thinking about a young woman you would like to
                  recommend before August 15. Think about women in your
                  community who exhibit excellence in leadership, academics,
                  extracurricular activities, community service and potential
                  for future success.
                </Typography>
              </Grid>
              <Grid item container xs={6} spacing={1}>
                <Grid item xs={12}>
                  <ButtonLink
                    href="https://www.peointernational.org/wp-content/uploads/2023/11/starproceduresandgeneralinformation1.2022final.pdf"
                    label="Policies and Procedures"
                  />
                </Grid>
                <Grid item xs={12}>
                  <ButtonLink
                    href="https://www.peointernational.org/wp-content/uploads/2025/06/STAR-Local-Chapter-Resource-2025.pdf"
                    label="Local Chapter Resource"
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} padding>
                <Divider />
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1" padding>
                  2. Interview your candidate. An in-person interview is best,
                  but if that is not an option, you can interview your candidate
                  via a phone call or videoconference.
                </Typography>
              </Grid>
              <Grid item xs={6} />
              <Grid item xs={12} padding>
                <Divider />
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1" padding>
                  3. After a successful chapter vote, complete the online STAR
                  Recommendation form. The form is available between August 15
                  and October 15 each year.
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2025/05/Chapter-Form-Instructions-all-projects-08.18.25.pdf"
                  label="Instructions for the online Recommendation Form"
                />
              </Grid>
            </Grid>
            <Grid item xs={12} padding>
              <Divider />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" padding>
                The P.E.O. Executive Office will email the student a link to the
                online application portal and instructions for logging in. The
                student has 30 days from the date the link is sent to complete
                and submit the Student Profile, Student Activity Charts,
                original essay not to exceed 700 words, two recommendations and
                unofficial high school transcript (through the 11th grade/junior
                year).
              </Typography>
            </Grid>

            <Grid item xs={12} padding>
              <Typography variant="body1" padding>
                Your chapter’s STAR committee may meet with the student to
                proofread her essay and offer suggestions.
              </Typography>
            </Grid>
            <Grid item xs={12} padding>
              <Typography variant="body1" padding>
                Awards are announced annually by April 30, and notification is
                sent to all applicants and recommending chapters. The P.E.O.
                Executive Office will mail recipient award certificates to
                recommending chapters for presentation at a high school awards
                ceremony or at your local chapter meeting.
              </Typography>
            </Grid>
            <Grid item xs={12} padding>
              <Typography variant="body1" padding>
                Your chapter can also use the STAR Scholarship Recipient Media
                Kit (links below) to share information about your recipient with
                local media outlets. The kit includes a photography and
                publicity consent form for your recipient to sign.
              </Typography>
            </Grid>
            <Grid item xs={12} textAlign="center">
              <ButtonLink
                href="https://www.peointernational.org/wp-content/uploads/2023/11/P.E.O.-Photograph-and-Publicity-Consent-Form.pdf"
                label="Photography and Publicity Consent Form"
              />
            </Grid>
            <Grid item xs={12} textAlign="center">
              <ButtonLink
                href="https://www.peointernational.org/wp-content/uploads/2025/05/STARNewsReleaseSample_202507_Final_4a7af070-453e-11f0-bfec-325096b39f47.2.docx"
                label="News Release Sample"
              />
            </Grid>
          </CardContent>
          <CardActions>
            <Grid container xs={12} padding>
              <Grid item xs={12} textAlign="center">
                <Link
                  href="https://peointernational.communityforce.com/Funds/FundDetails.aspx?496F49596D593768464E3537506B6F754D5442315A38332B6F6C746D564B6D463958476C6673347367426967677048664F476A4976392B68326F4B6E6A5575432B65472B65535045684E453D"
                  target="_blank"
                  rel="noopener"
                  sx={{ textDecoration: 'none' }}
                >
                  <Button variant="contained" color="primary">
                    STAR Recommendation Form
                  </Button>
                </Link>
              </Grid>

              <Grid item xs={12} textAlign="center">
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ maxWidth: 600, mx: 'auto', mt: 1 }}
                >
                  Click the button above to be directed to the CommunityForce
                  application system. CommunityForce is a third party vendor we
                  utilize for managing applications. Separate login credentials
                  will be required.
                </Typography>
              </Grid>
            </Grid>
          </CardActions>
        </Card>
      </Grid>
      <Grid item xs={12} padding>
        <Card
          sx={{
            boxShadow: 3,
            borderRadius: 2,
            overflow: 'auto',
          }}
        >
          <CardHeader
            title="Eligibility Requirements"
            sx={{ pb: 0 }}
            subheader="A woman is eligible for consideration for a STAR Scholarship if she:"
          />
          <CardContent>
            <Grid container xs={12}>
              <Grid item xs={12}>
                <Typography variant="body1" padding>
                  <Circle sx={{ fontSize: 10, pr: 2 }} />
                  Is recommended by a local chapter of the P.E.O. Sisterhood
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1" padding>
                  <Circle sx={{ fontSize: 10, pr: 2 }} />
                  Is a citizen or legal permanent resident of the United States
                  or Canada
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1" padding>
                  <Circle sx={{ fontSize: 10, pr: 2 }} />
                  Exhibits excellence in leadership, academics, extracurricular
                  activities, community service and potential for future success
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" padding>
                <Circle sx={{ fontSize: 10, pr: 2 }} />
                Plans to attend an accredited postsecondary education
                institution in the United States or Canada full time or part
                time in the fall of the academic year following her high school
                graduation
              </Typography>
            </Grid>

            <Grid
              item
              container
              xs={12}
              justifyContent="center"
              alignItems="center"
              direction="column"
            >
              <Grid
                item
                xs={12}
                textAlign="center"
                justifyContent="center"
                alignItems="center"
                paddingBottom={2}
              >
                <Image
                  src={
                    'https://www.peointernational.org/wp-content/uploads/2023/09/STAR-qualities-graphic.png'
                  }
                  alt="Logo"
                  sx={{ maxWidth: '300px' }}
                  width={'40vw'}
                />
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" padding>
                The applications of individuals who satisfy these eligibility
                criteria will be evaluated on a nondiscriminatory basis without
                consideration of race, age, national origin, religious
                affiliation, disability or P.E.O. connection.
              </Typography>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} padding>
        <Card
          sx={{
            boxShadow: 3,
            borderRadius: 2,
            overflow: 'auto',
          }}
        >
          <CardHeader title="Application Process" sx={{ pb: 0 }} />
          <CardContent>
            <Grid container xs={12}>
              <Grid item xs={12}>
                <Typography variant="body1" padding>
                  Members of a local P.E.O. chapter will interview a student
                  before deciding to recommend her.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1" padding>
                  After a local chapter recommends a student, the P.E.O.
                  Executive Office will email the applicant instructions for
                  logging into an online account to complete her portion of the
                  application. This must be submitted no more than 30 days after
                  she receives the email.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1" padding>
                  The application includes information about the student and her
                  extracurricular and community service/volunteer activities, a
                  700-word essay, two letters of recommendation and an
                  unofficial high school transcript (through 11th grade-/-junior
                  year).
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1" padding>
                  Awards are announced annually by April 30, and notification is
                  sent to all applicants and recommending chapters.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1" padding textAlign="center">
                  Additional Resources for Students:
                </Typography>
              </Grid>
              <Grid item xs={12} textAlign="center">
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2023/11/starproceduresandgeneralinformation1.2022final.pdf"
                  label="Policies and Procedures"
                />
              </Grid>
              <Grid item xs={12} textAlign="center">
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2025/06/STAR-Student-Application-Instructions-2025.pdf"
                  label="Student Application Instructions"
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
